import api from "app/lib/api";
import endpoints from "static/endpoints";

export const login = async (payload) => {
  const response = await api.post(endpoints.auth.login, payload);
  return response;
};

export const cognitoLogin = async () => {
  const response = await api.get(endpoints.auth.cognitoLogin);
  return response;
};

export const logout = async () => {
  const response = await api.get(endpoints.auth.logout);
  return response;
};

export const refreshToken = async () => {
  const response = await api.post(endpoints.auth.refreshToken);
  return response;
};
